export default "https://cdn-static.gokick.com/assets/c3e2404f2f1be1cd3bf75e8d7804f871d91db3b2/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";